import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useIsAuthenticated } from '@azure/msal-react';
// eslint-disable-next-line import/no-cycle
import { useSearchParams } from 'react-router-dom';
// eslint-disable-next-line import/no-cycle
import JobDetailsMobile from '../JobDetailsMobile/JobDetailsMobile';
import { fetchJob, fetchPublicJob } from '../../../../actions/job';
// eslint-disable-next-line import/no-cycle
import JobDetails from '../JobDetails/JobDetails';
import QuickApply from '../../../quickapply';
import QuickApplyV2 from '../../../quickapplyv2';
import NoResults from '../../../common/NoResults/NoResults';
import { BlockOutlined } from '@mui/icons-material';
import colors from '../../../../scss/colors';
import BackButton from '../../../common/buttons/BackButton/BackButton';

const FullScreenJobPage = ({ id, onClose = () => {}, forMobile = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const isAuthenticated = useIsAuthenticated();
  const job = useSelector((state) => state.job.response);
  const pending = useSelector((state) => state.job.pendingFlag);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchJob(id));
    } else {
      dispatch(fetchPublicJob(id));
    }
  }, [isAuthenticated, id]);

  if (job?.StatusCode === 404) {
    return (
      <NoResults icon={<BlockOutlined sx={{ color: colors.BRAND_BLUE, fontSize: '40px' }} />} primaryTxt={t('dashboard.jobs.notfound')} secondaryTxt={t('dashboard.jobs.notfoundtext')} isMobile={forMobile}>
        <div className='d-flex w-full px-4 pt-4'>
          <BackButton />
        </div>
      </NoResults>
    )
  }

  return (
    <>
      {!pending &&
        job &&
        (forMobile ? <JobDetailsMobile job={job} fullJob onClose={onClose} /> : <JobDetails job={job} fullJob />)}
      {searchParams.get('action') === 'apply' && (isAuthenticated ? <QuickApply /> : <QuickApplyV2 />)}
    </>
  );
};

export default FullScreenJobPage;
